/* eslint-disable arrow-body-style */
import React, { useState, createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import './Tabs.scss'

const TabsContext = createContext()

export const Tabs = ({ value, onValueChange, children, className = '' }) => {
  const [activeTab, setActiveTab] = useState(value)

  const handleTabChange = (newValue) => {
    setActiveTab(newValue)
    if (onValueChange) {
      onValueChange(newValue)
    }
  }

  React.useEffect(() => {
    setActiveTab(value)
  }, [value])

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab: handleTabChange }}>
      <div className={`custom-tabs ${className}`}>
        {children}
      </div>
    </TabsContext.Provider>
  )
}

Tabs.propTypes = {
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const TabsList = ({ children, className = '' }) => {
  return (
    <div className={`custom-tabs-list ${className}`} role="tablist">
      {children}
    </div>
  )
}

TabsList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const TabsTrigger = ({ value, children, className = '' }) => {
  const { activeTab, setActiveTab } = useContext(TabsContext)
  const isActive = activeTab === value

  return (
    <button
      type="button"
      role="tab"
      aria-selected={isActive}
      className={`custom-tabs-trigger ${isActive ? 'active' : ''} ${className}`}
      onClick={() => setActiveTab(value)}
      data-state={isActive ? 'active' : 'inactive'}
    >
      {children}
    </button>
  )
}

TabsTrigger.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const TabsContent = ({ value, children, className = '' }) => {
  const { activeTab } = useContext(TabsContext)
  const isActive = activeTab === value

  if (!isActive) return null

  return (
    <div className={`custom-tabs-content ${className}`} role="tabpanel">
      {children}
    </div>
  )
}

TabsContent.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
